import api from '../../lib/api';
import {
  url_api_v1_mk_delete,
  url_kit_documents,
  url_kit_documents_put,
} from '../../lib/apiUrl';
import { getFileMetadata } from '../../lib/getFileMetadata';
import buildFormData from '../../lib/buildFormData';
import convertToMp4Job from '../../lib/convertToMp4Job';
import waitJobComplete from '../../lib/waitJobComplete';

class KitDocumentService {
  createKitDocument = async (fileUppy: any, category_id: number, mediakit_uuid: string) => {
    try {
      await this.handleFileConvert(fileUppy);
      await this.handleSubmit(fileUppy, category_id, mediakit_uuid);
    } catch (error) {
      throw error;
    }
  };
  updateKitDocument = async (
    fileUppy: any,
    category_id: number,
    mediakit_uuid: string,
    kit_document_uuid: string,
    replace_crop: number
  ) => {
    try {
      await this.handleFileConvert(fileUppy);
      await this.handleSubmitUpdate(
        fileUppy,
        category_id,
        mediakit_uuid,
        kit_document_uuid,
        replace_crop
      );
    } catch (error) {
      throw error;
    }
  };
  handleFileConvert = async (file) => {
    if (!file.type.includes('video')) return;

    console.log('handleFileConvert start')
    if (file.type.includes('mp4')) {
      const { Job } = await convertToMp4Job(
        file.s3Multipart.key,
        file.s3Multipart.key.replace('.mp4', '-converted')
      );
      await waitJobComplete(Job.id);
    } else {
      const { Job } = await convertToMp4Job(file.s3Multipart.key);
      await waitJobComplete(Job.id);
    }
    console.log('handleFileConvert done')
  };

  handleSubmit = async (fileUppy: any, category_id: number, kit_uuid: string) => {
    const metadata = await getFileMetadata(fileUppy);
    const postData = {
      name: fileUppy.data.name,
      category_id: category_id,
      record_id: kit_uuid, // hairkit, work, global id
      blob: metadata,
    };
    const url = url_kit_documents;
    // /hair_make_up_kits/9JQ2Ixzo6bQUQudl8z0oag/kit_documents
    const respKitDocument = await api.postForm(url, postData);
    console.log('respBlob', respKitDocument);
    if (respKitDocument.status !== 200 && respKitDocument.status !== 201) {
      throw new Error('Error creating Blob.');
    }
  };
  handleSubmitUpdate = async (
    fileUppy: any,
    category_id: number,
    kit_uuid: string,
    kit_document_uuid: string,
    replace_crop: number
  ) => {
    const metadata = await getFileMetadata(fileUppy);
    const postData = {
      name: fileUppy.data.name,
      category_id: category_id,
      record_id: kit_uuid, // hairkit, work, global id
      blob: metadata,
      kit_document_uuid: kit_document_uuid,
      replace_crop: replace_crop,
    };
    const url = url_kit_documents_put.replace(':kit_document_uuid', kit_document_uuid);
    // /hair_make_up_kits/9JQ2Ixzo6bQUQudl8z0oag/kit_documents
    const respKitDocument = await api.putForm(url, postData);
    console.log('respBlob', respKitDocument);
    if (respKitDocument.status !== 200 && respKitDocument.status !== 201) {
      throw new Error('Error creating Blob.');
    }
  };
  deleteMediaKitDocument = async (mk_uuid: any, kit_id: any) => {
    try {
      const url = url_api_v1_mk_delete.replace('mk_id', mk_uuid).replace('kit_id', kit_id);
      const response = await api.delete(url);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error creating job.');
      }
      return true;
    } catch (error) {
      throw error;
    }
  };
}

const kitDocumentService = new KitDocumentService();

export default kitDocumentService;
